export default "__VITE_ASSET__BNv2cRw6__"